import React from "react";
import clsx from "clsx";
import {Button, Grid} from "./index";
import { colors, space, radius, borders, fontSize } from "../../design/tokens";

export function Tab({ label, icon, active, onClick }) {
  return (
    <Button
      onClick={onClick}
      style={{
        fontSize: "clamp(10px, 0.85vw ,16px)",
        padding:space.xs,
        maxWidth: "clamp(90px, 10.5vw, 200px)" 
    }}
    //   className={clsx(
    //     "flex items-center gap-2 px-4 py-2 border-b-2 transition-colors",
    //     active
    //       ? "border-blue-500 text-blue-500"
    //       : "border-transparent text-gray-500 hover:text-gray-800"
    //   )}
    >
      {icon}
      <span>{label}</span>
    </Button>
  );
}

export function Tabs({ value, onChange, children }) {
  return (
    <Grid>
      {React.Children.map(children, (child, index) =>
        React.cloneElement(child, {
          active: value === index,
          onClick: (event) => onChange?.(event, index),
        })
      )}
    </Grid>
  );
}